import { render, staticRenderFns } from "./MountedFlag.vue?vue&type=template&id=719ad731&scoped=true&lang=pug"
import script from "./MountedFlag.vue?vue&type=script&lang=js"
export * from "./MountedFlag.vue?vue&type=script&lang=js"
import style0 from "./MountedFlag.vue?vue&type=style&index=0&id=719ad731&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ad731",
  null
  
)

export default component.exports